import { ButtonGroup, InputAdornment, TextField } from "@mui/material";
import { useCallback, useMemo } from "react";

import InputDateRangePickerComponent from "../input-date-range-picker/InputDateRangePickerComponent";
import InputOptionComponent from "../input-option/InputOptionComponent";

import "./FilterGroupComponent.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  generateUrlWithParams,
  paramParsify,
  paramStringify,
} from "utils/queryParams";
import { useDebounceCallback } from "usehooks-ts";

const FilterGroupComponent = ({
  searchPlaceholder = "",
  searchParamsQueryKey = "search",
  filterDate,
  filterQuery,
  filterStatus,
  filterActionType,
  actionTypeOptions,
  statusOptions,
  onChange,
  isMaxOneYear,
  showDateRangePicker = true,
  showStatusFilter = true,
  showTypeFilter = true,
  showSearch = true,
  dateLabel,
  delayTime = 500,
  uniquePageParams,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const parsed = useMemo(() => paramParsify(location?.search), [location]);

  const defaultKeyword = useMemo(
    () => String(parsed?.[searchParamsQueryKey] ?? ""),
    [parsed, searchParamsQueryKey],
  );

  const debounced = useDebounceCallback((val) => {
    const stringified = paramStringify({
      ...parsed,
      [uniquePageParams || "page"]: 1,
      [searchParamsQueryKey]: val,
    });
    navigate(generateUrlWithParams(location?.pathname, stringified));
  }, delayTime);

  const handleOnChangeInput = useCallback(
    (value) => {
      debounced(value);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [parsed],
  );

  const updateFilter = () => {
    onChange({
      date: filterDate,
      query: filterQuery,
      status: filterStatus,
      actionType: filterActionType,
    });
  };

  const selectFilter = (option, type) => {
    if (type === "date") filterDate = { ...option, type };
    if (type === "query") filterQuery = { ...option, type };
    if (type === "status") filterStatus = { ...option, type };
    if (type === "action-type") filterActionType = { ...option, type };

    updateFilter();
  };

  return (
    <div className='filter-group'>
      <ButtonGroup>
        {showSearch && (
          <TextField
            className='filter-group-input'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <img src='/images/search.svg' alt='search-icon' />
                </InputAdornment>
              ),
            }}
            type='search'
            placeholder={searchPlaceholder}
            defaultValue={defaultKeyword}
            onChange={(event) => handleOnChangeInput(event.target.value)}
          />
        )}

        {showDateRangePicker && (
          <InputDateRangePickerComponent
            maxOneYear={isMaxOneYear}
            label={dateLabel}
            valueDateEnd={filterDate?.value.dateEnd}
            valueDateStart={filterDate?.value.dateStart}
            onSelect={(option) => selectFilter(option, "date")}
          />
        )}

        {showStatusFilter && (
          <InputOptionComponent
            label='Status'
            options={statusOptions}
            value={filterStatus}
            onSelect={(option) => selectFilter(option, "status")}
          />
        )}

        {showTypeFilter && (
          <InputOptionComponent
            label='Action Type'
            options={actionTypeOptions}
            value={filterActionType}
            onSelect={(option) => selectFilter(option, "action-type")}
          />
        )}
      </ButtonGroup>
    </div>
  );
};

export default FilterGroupComponent;
